import type { PlgAuthConfig } from "plg/types";
import { PLG_GOOGLE_CALLBACK_ROUTE } from "constants/routes";
import { savePendingSso } from "plg/auth/ssoRedirect";
import { plgNavigation } from "plg/api/plgApi";

const GOOGLE_AUTH_URL = "https://accounts.google.com/o/oauth2/v2/auth";
export const GOOGLE_CALLBACK_PATH = PLG_GOOGLE_CALLBACK_ROUTE;

const b64url = (bytes: Uint8Array) =>
  btoa(String.fromCharCode(...Array.from(bytes))).replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "");

export function randomString(byteLength = 32): string {
  const bytes = new Uint8Array(byteLength);
  crypto.getRandomValues(bytes);
  return b64url(bytes);
}

export async function pkceChallenge(verifier: string): Promise<string> {
  const digest = await crypto.subtle.digest("SHA-256", new TextEncoder().encode(verifier));
  return b64url(new Uint8Array(digest));
}

export const googleRedirectUri = (config: PlgAuthConfig) =>
  config.google.redirectUri || `${window.location.origin}${GOOGLE_CALLBACK_PATH}`;

export function buildGoogleAuthUrl(args: { clientId: string; redirectUri: string; state: string; codeChallenge: string }): string {
  const params = new URLSearchParams({
    client_id: args.clientId,
    redirect_uri: args.redirectUri,
    response_type: "code",
    scope: "openid email profile",
    state: args.state,
    code_challenge: args.codeChallenge,
    code_challenge_method: "S256",
    prompt: "select_account",
  });
  return `${GOOGLE_AUTH_URL}?${params.toString()}`;
}

/** Leaves for Google in this tab; Google returns to the callback page (GoogleOAuthCallbackPage). */
export async function startGoogleSignIn(config: PlgAuthConfig): Promise<void> {
  const codeVerifier = randomString(48);
  const state = randomString(16);
  const codeChallenge = await pkceChallenge(codeVerifier);
  savePendingSso({ provider: "google", state, codeVerifier });
  plgNavigation.go(buildGoogleAuthUrl({ clientId: config.google.clientId, redirectUri: googleRedirectUri(config), state, codeChallenge }));
}
